class DragVector {
  constructor(
    public depth: AnyFixMe,
    public position: AnyFixMe,
  ) {}

  isOutside() {
    return this.depth < 0;
  }

  isInside() {
    return this.depth > 0;
  }

  isBack() {
    return this.position < 0;
  }

  isForward() {
    return this.position > 0;
  }

  isZero() {
    return this.depth === 0 && this.position === 0;
  }

  toString() {
    return [this.depth, this.position].join(', ');
  }
}

export default DragVector;
